import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { HelpButton } from 'components/common/census/HelpButton';
import { useHistory } from 'react-router-dom';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import ManageAddEmployeesCensusPageStore, {
  ManageAddEmployeesCensusPageStoreContext,
  useManageAddEmployeesCensusPageStoreContext,
} from 'store/pages/enrollment/manage-add-employees/census/pageStore';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = () => {
  const pageStore = useManageAddEmployeesCensusPageStoreContext();
  return <BasicCensusFlowLayout pageStore={pageStore} />;
};

const CensusUploadPage: React.FC = () => {
  const history = useHistory();
  const { groupId, periodId } = useEnrollmentDomainParams();

  function redirectBack(): void {
    history.push(`/employee-elections/${periodId}?groupId=${groupId}`);
  }

  const pageStore = useMemo(() => new ManageAddEmployeesCensusPageStore({ groupId, enrollmentPeriodId: periodId }), []);

  return (
    <ProposalStatusLayout>
      <ManageAddEmployeesCensusPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageHeader title={CARD_DATA.CENSUS_IMPORT.title} onRedirect={redirectBack} subtitle={<HelpButton />} />
          <PageContent />
        </PageWrapperStyled>
      </ManageAddEmployeesCensusPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default CensusUploadPage;
